







































































import { Vue, Component } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { mapActions } from "vuex";
import { signIn } from "../utils/authentication.js";

@Component
export default class Authentication extends Vue {
  @Action("app/addNotification") addNotification: any;
  @Action("user/setUser") setUser: any;

  videos = [
    {
      id: "vfTJ4vmIsO4",
      link: "https://www.youtube.com/embed/vfTJ4vmIsO4?start=260"
    },
    {
      id: "hI89r4LqaCc",
      link: "https://www.youtube.com/embed/hI89r4LqaCc"
    },
    {
      id: "wKimU8jy2a8",
      link: "https://www.youtube.com/embed/wKimU8jy2a8"
    },
    {
      id: "ZoGH7d51bvc",
      link: "https://www.youtube.com/embed/ZoGH7d51bvc?start=534"
    }
  ];

  async signIn(provider: any) {
    try {
      const { user } = await signIn(provider);
      this.setUser(user);

      this.addNotification({ text: "Vous êtes connecté", status: "info" });
    } catch (error) {
      switch (error.code) {
        case "auth/account-exists-with-different-credential":
          this.addNotification({
            text: `Ton compte n'est pas assicié à ${error.credential.signInMethod}. Essaye une autre méthode d'authentification`,
            status: "error"
          });

          break;

        default:
          this.addNotification({
            text: "Il y a eu un problème pour vous authentifier",
            status: "error"
          });
          break;
      }
    }
  }
}
